import { render, staticRenderFns } from "./MathJax.vue?vue&type=template&id=4921f552&scoped=true"
import script from "./MathJax.vue?vue&type=script&lang=js"
export * from "./MathJax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4921f552",
  null
  
)

export default component.exports